import { render, staticRenderFns } from "./materials_list.vue?vue&type=template&id=432303d0&lang=pug&"
import script from "./materials_list.vue?vue&type=script&setup=true&lang=js&"
export * from "./materials_list.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./materials_list.vue?vue&type=style&index=0&id=432303d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports